<template>
  <app-collapse
    accordion
    :type="collapseType"
    class="client-items"
  >

    <app-collapse-item
      v-if="!debtorsBelongToCompany"
      :title="$t('DEBTIA_CLIENT')"
    >
      <b-row
        class="bt-1"
      >
        <!-- User Info: Left col -->
        <b-col
          cols="12"
          xl="6"
          class="d-flex justify-content-between flex-column row-right-border pt-1"
        >
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_NAME') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">
                <b-button
                  v-if="$ability.can(constants.action.permissionClientEdit, constants.resource.client)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  :to="{ name: 'client-view', params: { id: userData.data.client.id } }"
                  target="_blank"
                  class="edit-client-btn"
                >
                  {{ userData.data.client.name ? userData.data.client.name : 'N/A' }}
                  <feather-icon
                    icon="ExternalLinkIcon"
                  />
                </b-button>
              </small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_USERNAME') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.client.username ? userData.data.client.username : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_EMAIL') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75"><a :href="'mailto:' + userData.data.client.email">{{ userData.data.client.email ? userData.data.client.email : 'N/A' }}</a></small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_PHONE') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.client.phone ? userData.data.client.phone : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_LOGIN') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.client.loginStatus === '0' ? "Not Allowed" : "Allowed" }}</small>
            </div>
          </div>
        </b-col>
        <!-- User Info: Left col -->
        <b-col
          cols="12"
          xl="6"
          class="d-flex justify-content-between flex-column pt-1"
        >
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_CONTACT_PERSON') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.client.contact_person ? userData.data.client.contact_person : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_DEBTOR_TYPE') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.debtor_type }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center client-margin-bottom"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_BIRTHDATE') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.client.birth_date ? userData.data.client.birth_date : 'N/A' }}</small>
            </div>
          </div>
        </b-col>
      </b-row>
    </app-collapse-item>

    <app-collapse-item
      :title="$t('DEBTIA_REPRESENTATIVE')"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <div
          v-if="!hasRepresentative"
          class="demo-spacing-0 alert-class"
        >
          <b-alert
            variant="warning"
            show
          >
            <div class="alert-body">
              {{ $t('DEBTIA_REPRESENTATIVE_FORM_MSG') }}
            </div>
          </b-alert>
        </div>
        <validation-observer
          #default="{ handleSubmit }"
          ref="refRepresentativeFormObserver"
        >
          <b-form
            ref="representativeForm"
            @submit.prevent="handleSubmit(onRepresentativeSubmit)"
            @reset.prevent="resetForm"
          >
            <b-row>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="Name"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_NAME')"
                    label-for="name"
                  >
                    <b-form-input
                      id="name"
                      v-model="representative.name"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Field: House Number -->
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('DEBTIA_COMPANY')"
                  label-for="company"
                >
                  <b-form-input
                    id="company"
                    v-model="representative.company"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Place -->
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('DEBTIA_PHONE')"
                  label-for="phone"
                >
                  <b-form-input
                    id="phone"
                    v-model="representative.phone"
                    type="number"
                    trim
                  />
                </b-form-group>
              </b-col>

              <!-- Field: Zipcode -->
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-group
                    :label="$t('DEBTIA_EMAIL')"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="representative.email"
                      :state="getValidationState(validationContext)"
                      trim
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-row
                class="debtor-address"
              >
                <b-col
                  cols="12"
                  lg="12"
                ><h4>{{ $t('DEBTIA_ADDRESS') }}</h4></b-col>

                <!-- Field: House Number -->
                <b-col
                  cols="12"
                  lg="4"
                >
                  <validation-provider
                    #default="validationContext"
                    name="House Number"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_HOUSE_NUMBER')"
                      label-for="house-number"
                    >
                      <b-form-input
                        id="house-number"
                        v-model="representative.address.house_number"
                        :state="getValidationState(validationContext)"
                        trim
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Field: House Number -->
                <b-col
                  cols="12"
                  lg="4"
                >
                  <validation-provider
                    #default="validationContext"
                    name="Road Name"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_ROAD_NAME')"
                      label-for="road-name"
                    >
                      <b-form-input
                        id="road-name"
                        v-model="representative.address.road_name"
                        :state="getValidationState(validationContext)"
                        trim
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Field: Place -->
                <b-col
                  cols="12"
                  lg="4"
                >
                  <b-form-group
                    :label="$t('DEBTIA_PLACE_NAME')"
                    label-for="place"
                  >
                    <b-form-input
                      id="place"
                      v-model="representative.address.place"
                      trim
                    />
                  </b-form-group>
                </b-col>

                <!-- Field: Zipcode -->
                <b-col
                  cols="12"
                  lg="4"
                >
                  <validation-provider
                    #default="validationContext"
                    name="Zip Code"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_ZIP_CODE')"
                      label-for="zip-code"
                    >
                      <b-form-input
                        id="zip-code"
                        v-model="representative.address.zip_code"
                        :state="getValidationState(validationContext)"
                        trim
                        @change="getCityName($event)"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Field: City -->
                <b-col
                  cols="12"
                  lg="4"
                >
                  <validation-provider
                    #default="validationContext"
                    name="City"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_CITY')"
                      label-for="city"
                    >
                      <b-form-input
                        id="city"
                        v-model="representative.address.city"
                        :state="getValidationState(validationContext)"
                        trim
                        @change="getZipCode($event)"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- Field: Country -->
                <b-col
                  cols="12"
                  lg="4"
                >
                  <validation-provider
                    #default="validationContext"
                    name="Country"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('DEBTIA_COUNTRY')"
                      label-for="country"
                    >
                      <v-select
                        v-model="representative.address.country_id"
                        :disabled="busy"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="countries"
                        :reduce="val => val.value"
                        :clearable="false"
                        input-id="select-country"
                        :value="'Select Country'"
                      >
                        <template
                          #selected-option-container="{ option }"
                        >
                          <div class="vs__selected">
                            {{ $t(option.label) }}</div>
                        </template>
                        <template
                          slot="option"
                          slot-scope="option"
                        >
                          {{ $t(option.label) }}
                        </template>
                      </v-select>
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>

              </b-row>
            </b-row>
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1 debtor-save"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              type="submit"
            >
              {{ hasRepresentative ? $t('DEBTIA_UPDATE') : $t('DEBTIA_ADD') }}
            </b-button>
            <b-button
              v-if="hasRepresentative"
              variant="outline-secondary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1 debtor-save"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="representativeClick"
            >
              {{ $t('DEBTIA_REMOVE_REPRESENTATIVE') }}
            </b-button>
          </b-form>

        </validation-observer>
      </b-overlay>
    </app-collapse-item>
    <app-collapse-item
      :title="$t('DEBTIA_DEBT_CASES')"
      class="cases-table"
    >
      <b-table
        ref="refUserListTable"
        class="position-relative resource-listing"
        :items="caseitems"
        responsive
        :fields="casefields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('DEBTIA_NO_RECORD_MSG')"
        :sort-desc.sync="isSortDirDesc"
        selectable
        @row-selected="onRowSelected"
      >

        <template #cell(id)="tdata">
          <b-link
            :to="{ name: 'case-details', params: { id: tdata.item.id } }"
            target="_blank"
          >
            <div>
              {{ (tdata.item.g_prefix) ? tdata.item.g_prefix+tdata.item.id : tdata.item.id }}
            </div>
          </b-link>
        </template>
        <template #cell(base_type)="tdata">
          <b-link
            :to="{ name: 'case-details', params: { id: tdata.item.id } }"
            target="_blank"
          >
            <div>{{ (tdata.item.base_type) ? tdata.item.base_type.name : '' }}</div>
          </b-link>
        </template>
        <template #cell(client_name)="tdata">
          <b-media vertical-align="center">
            <b-link
              class="font-weight-bold d-block text-nowrap client-name"
              :to="{ name: 'case-details', params: { id: tdata.item.id } }"
              target="_blank"
            >
              <div>
                <div>{{ tdata.item.client.name }}</div>
              </div>
            </b-link>
          </b-media>
        </template>
        <template #cell(case_group)="tdata">
          <b-link
            :to="{ name: 'case-details', params: { id: tdata.item.id } }"
            target="_blank"
          >
            <div>{{ (tdata.item.debt_case_group) ? tdata.item.debt_case_group.title : 'N/A' }}</div>
          </b-link>
        </template>
        <template #cell(active_process)="tdata">
          <b-link
            :to="{ name: 'case-details', params: { id: tdata.item.id } }"
            target="_blank"
          >
            <div>{{ (tdata.item.process_case && (tdata.item.process_case.length > 0 && tdata.item.process_case[0].completed == 0)) ? tdata.item.process_case[0].process.title : $t('DEBTIA_DEBT_CASE_ACTIVE_PROCESS') }}</div>
          </b-link>
        </template>
        <template #cell(status)="tdata">
          <b-link
            :to="{ name: 'case-details', params: { id: tdata.item.id } }"
            target="_blank"
          >
            <b-badge
              v-if="tdata.item.status === 0 || tdata.item.status === null"
              pill
              variant="warning"
            >
              {{ $t('DEBTIA_PENDING') }}
            </b-badge>
            <b-badge
              v-if="tdata.item.status === 1"
              pill
              variant="success"
            >
              {{ $t('DEBTIA_ACCEPTED') }}
            </b-badge>
            <b-badge
              v-if="tdata.item.status === 2"
              pill
              variant="danger"
            >
              {{ $t('DEBTIA_DECLINED') }}
            </b-badge>
            <b-badge
              v-if="tdata.item.status === 3"
              pill
              variant="danger"
            >
              {{ $t('DEBTIA_TERMINATED') }}
            </b-badge>
            <b-badge
              v-if="tdata.item.status === 4"
              pill
              variant="warning"
            >
              {{ $t('DEBTIA_PAUSED') }}
            </b-badge>
          </b-link>
        </template>

      </b-table>
    </app-collapse-item>
    <notes-section
      :person-type="2"
    />
  </app-collapse>
</template>

<script>
import {
  BTable, BRow, BCol, BFormGroup, BMedia, BMediaBody, BFormInput, BButton, BFormInvalidFeedback, BForm, BAlert, BOverlay, BBadge, BLink,
} from 'bootstrap-vue'
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required, email } from '@validations'
import constants from '@/app-configs/constants'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import countries from '@/countries'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
import NotesSection from '@/views/commonfiles/NotesSection.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    BTable,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BMedia,
    BMediaBody,
    BFormInput,
    BButton,
    BFormInvalidFeedback,
    BForm,
    vSelect,
    BAlert,
    BOverlay,
    NotesSection,
    BBadge,
    BLink,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      busy: false,
      countries,
      fileitems: this.userData.data.client_files,
      loader: false,
      debtorfields: [{ key: 'id', sortable: true }, { key: 'name', sortable: false, label: this.$t('DEBTIA_NAME') }, 'action'],
      // casefields: ['id', { key: 'base_type', sortable: false, label: this.$t('DEBTIA_BASE_TYPE') }, { key: 'bc_case_id', sortable: false, label: this.$t('DEBTIA_BC_ID') }],
      casefields: [
        { key: 'id', sortable: true },
        { key: 'base_type', sortable: true, label: i18n.t('DEBTIA_BASE_TYPE') },
        { key: 'client_name', sortable: true, label: i18n.t('DEBTIA_CLIENT_NAME') },
        { key: 'case_group', label: i18n.t('DEBTIA_CASE_GROUP') },
        { key: 'active_process', label: i18n.t('DEBTIA_ACTIVE_PROCESS') },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
      ],
      filefields: ['id', 'title', 'show_details'],
      debtoritems: this.userData.data.debtors,
      caseitems: this.userData.data.debt_case,
      required,
      email,
      hasRepresentative: false,
      representative: {
        id: 0,
        debtor_id: this.$route.params.id,
        name: '',
        company: '',
        phone: '',
        email: '',
        address: {
          house_number: '',
          place: '',
          road_name: '',
          zip_code: '',
          city: '',
          country_id: 247,
        },
      },
      data: this.userData,
      constants,
      sortBy: 'DESC',
      isSortDirDesc: true,
      debtorsBelongToCompany: localStorage.getItem('debtorsBelongTo') === 'company',
    }
  },
  computed: {
    tableColumns() {
      const temp = [{ key: 'user', sortable: true, label: this.$t('DEBTIA_CLIENT') },
        { key: 'email', sortable: false, label: this.$t('DEBTIA_EMAIL') },
        { key: 'type', sortable: false, label: this.$t('DEBTIA_CLIENT_TYPE') },
        { key: 'login', sortable: false, label: this.$t('DEBTIA_LOGIN') },
        { key: 'actions', label: this.$t('DEBTIA_ACTION') },
      ]

      if (this.role === 'super-admin') {
        temp.splice(
          1, 0, { key: 'company', sortable: false, label: this.$t('DEBTIA_COMPANY') },
        )
      }

      return temp
    },
  },
  created() {
    this.getRepresentative()
  },
  setup(props) {
    const loginOptions = [
      { label: 'Allowed', value: '1' },
      { label: 'Not Allowed', value: '0' },
    ]
    const collapseType = 'margin'

    const {
      refRepresentativeFormObserver,
      refFormObserver,
      getValidationState,
    } = formValidation(props.userData)

    return {
      loginOptions,
      refFormObserver,
      refRepresentativeFormObserver,
      getValidationState,
      BFormInvalidFeedback,
      collapseType,
    }
  },
  methods: {
    onRowSelected(item) {
      this.selected = item
      this.$router.push(`/cases/details/v2/${item['0'].id}`)
    },
    getCityName(event) {
      axios.get(`settings/get-city-name-by-code?code=${event}`)
        .then(response => {
          if (response.data.data.city_name !== null) {
            this.representative.address.city = response.data.data.city_name
          }
        }).catch(error => {
          console.log(error)
        })
    },
    getZipCode(event) {
      axios.get(`settings/get-zip-code-by-city-name?city=${event}`)
        .then(response => {
          if (response.data.data.zip_code !== null) {
            this.representative.address.zip_code = response.data.data.zip_code
          }
        }).catch(error => {
          console.log(error)
        })
    },
    onRepresentativeSubmit() {
      let url = ''
      let msg = ''
      if (this.hasRepresentative) {
        url = '/representative/edit'
        msg = i18n.t('DEBTIA_REPRESENTATIVE_UPDATED')
      } else {
        url = '/representative/create'
        msg = i18n.t('DEBTIA_REPRESENTATIVE_ADDED')
      }
      this.loader = true
      axios
        .post(url, { ...this.representative })
        .then(response => {
          if (response.status) {
            this.representative.id = response.data.data.id
            this.loader = false
            this.hasRepresentative = true
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Message',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: msg,
              },
            })
          }
        })
    },
    getRepresentative() {
      if (this.data.data.representative) {
        this.hasRepresentative = true
        const { representative } = this.data.data
        this.representative.id = representative.id
        this.representative.name = representative.name
        this.representative.company = representative.company
        this.representative.phone = representative.phone
        this.representative.email = representative.email
        this.representative.address.road_name = representative.representative_address.road_name
        this.representative.address.house_number = representative.representative_address.house_no
        this.representative.address.place = representative.representative_address.place
        this.representative.address.zip_code = representative.representative_address.zip_code
        this.representative.address.city = representative.representative_address.city
        this.representative.address.country_id = representative.representative_address.country_id
      }
    },
    representativeClick() {
      if (this.hasRepresentative) {
        this.confirmButtonColor()
      } else {
        this.boxOpen = true
      }
    },
    // comfirm button color
    confirmButtonColor() {
      this.$swal({
        title: i18n.t('DEBTIA_SURE_MSG'),
        text: i18n.t('DEBTIA_REVERT_MSG'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          console.log('this.representative in delete ', this.representative)
          const { id } = this.representative
          axios.post('/representative/delete', { id })
            .then(response => {
              this.resetRepresentative()
              this.$refs.refRepresentativeFormObserver.reset()
              this.boxOpen = false
              this.hasRepresentative = false
              if (response.status) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: i18n.t('DEBTIA_REPRESENTATIVE_DELETED'),
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        }
      })
    },
    resetRepresentative() {
      this.representative = {
        id: 0,
        debtor_id: this.$route.params.id,
        name: '',
        company: '',
        phone: '',
        email: '',
        address: {
          house_number: '',
          place: '',
          road_name: '',
          zip_code: '',
          city: '',
          country_id: 247,
        },
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-file-btn {
  margin-bottom: 10px;
}

.detailcard {
  margin: 20px;
}

.filecolumn {
  width: 15%;
}

.filetable {
  width: 100%;
}
.debtor-address{
  padding: 15px 15px 0px 15px;
  border: 1px solid #d8d6de;
  border-radius: 10px;
  margin: 0px 15px 0px 15px;
}
.debtor-save{
  margin: 15px 15px 0px 0px;
}

.alert-class, .client-margin-bottom {
  margin-bottom: 20px;
}

.bt-1 {
  border-top: 1px solid #d9d9d9;
}
.cases-table .card-body {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 500px;
  padding-right: 10px;
}
.cases-table .card-body::-webkit-scrollbar {
    width: 12px;
}
.cases-table .card-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}
.cases-table .card-body::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
</style>
